import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import {
  GET_DATE_INFO,
  IGetDateInfoNode,
  IGetDateInfoResponse,
  IGetDateInfoVariables,
} from '../gql'

interface IProps {
  queryDate: string
  currentYear: number
}

export interface ICompDateDataType {
  status: 'new' | 'comp' | 'become-comp'
  weekNumber: number
}

const useGetDateInfo = ({ queryDate, currentYear }: IProps) => {
  const previousYear = currentYear - 1
  const { data, loading } = useQuery<
    IGetDateInfoResponse,
    IGetDateInfoVariables
  >(GET_DATE_INFO, {
    variables: {
      iQueryDate: queryDate,
    },
    skip: !queryDate,
  })

  return {
    compDateData: useMemo((): ICompDateDataType | null => {
      if (!data?.getDateInfo?.nodes?.[0]) return null

      const node = data.getDateInfo.nodes[0]

      // If the opening date is before the previous year, it's a comp store
      if (node.businessYear < previousYear) {
        return {
          status: 'comp',
          weekNumber: 0,
        }
      }

      // If the opening date is in the current year, it's a new store
      if (node.businessYear > previousYear) {
        return {
          status: 'new',
          weekNumber: 0,
        }
      }

      // If the opening date is in the previous year, it became comp during current year
      if (node.businessYear === previousYear) {
        return {
          status: 'become-comp',
          weekNumber: node.businessWeek,
        }
      }

      return {
        status: 'comp',
        weekNumber: 0,
      }
    }, [data, previousYear]),
    loading,
  }
}

export default useGetDateInfo
